module.exports = __webpack_public_path__ + "img/ban.c91f82cd.png";